/* ============================================================================
   EASTEAM quick view — Previously On media fix
   ----------------------------------------------------------------------------
   WHY THIS FILE EXISTS
   The section's [data-eaqv-looks] island builds a video's src with Liquid's
   `map: 'url'`, which returns an ARRAY rather than a string, so the story
   viewer was handed ["…mp4"] instead of "…mp4". The <video> tags in the strip
   itself are correct, because they use vs.url directly.

   Rather than keep two copies of the same media in sync, this makes the DOM the
   single source of truth: the viewer now reads each look's media straight off
   the tile the shopper clicked, and uses the island only for the caption
   (name, price, link). It overrides window.EAQuickViewLooks, which
   ea-quickview.js calls when a tile is clicked.

   Shipped as a companion so the 25KB main file did not have to be re-uploaded
   for a one-line data bug. FOLD IT IN next time ea-quickview.js is rewritten:
   fix the island to `assign vsrc = mm.sources | where: 'format','mp4' | last`
   then `{{ vsrc.url | json }}`, and delete this file and its <script> tag in
   snippets/ea-quickview.liquid.
   ==========================================================================*/
(function () {
  'use strict';

  window.EAQuickViewLooks = function (strip, meta) {
    var tiles = Array.prototype.slice.call(strip.querySelectorAll('[data-eaqv-look]'));
    return tiles.map(function (tile, i) {
      var v = tile.querySelector('video');
      var img = tile.querySelector('img');
      var m = (meta && meta[i]) || {};
      return {
        video: !!v,
        src: v ? v.getAttribute('src') : (img ? img.getAttribute('src') : ''),
        poster: v ? v.getAttribute('poster') : (img ? img.getAttribute('src') : ''),
        name: m.name || '',
        price: m.price || '',
        url: m.url || ''
      };
    });
  };
})();
